import { useRef, forwardRef, useCallback } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';
import VirtualizedListView from '../virtualizedListView';
import { useScrollMargin } from '../../../../utility/hooks';
import {
  baseVirtualizedListPropTypes,
  virtualizerConfigPropTypes,
  scrollElementRefPropType,
} from '../propTypes';

function ExternalElementVirtualizedListComponent(
  {
    count,
    gap,
    estimateSize,
    getItemKey,
    scrollElementRef = undefined,
    virtualizerRef,
    ...viewProps
  },
  ref
) {
  const viewportRef = useRef(null);
  const scrollMargin = useScrollMargin(viewportRef, scrollElementRef);

  const getScrollElement = useCallback(
    () => scrollElementRef?.current ?? null,
    [scrollElementRef]
  );

  const virtualizer = useVirtualizer({
    getScrollElement,
    getItemKey,
    scrollMargin,
    overscan: 5,
    count,
    gap,
    estimateSize,
  });

  return (
    <VirtualizedListView
      {...viewProps}
      ref={ref}
      virtualizer={virtualizer}
      virtualizerRef={virtualizerRef}
      usesExternalScroll
      viewportRef={viewportRef}
    />
  );
}

const ExternalElementVirtualizedList = forwardRef(
  ExternalElementVirtualizedListComponent
);

ExternalElementVirtualizedList.displayName = 'ExternalElementVirtualizedList';

ExternalElementVirtualizedList.propTypes = {
  ...baseVirtualizedListPropTypes,
  ...virtualizerConfigPropTypes,
  scrollElementRef: scrollElementRefPropType,
};

export default ExternalElementVirtualizedList;
